import { defaultBorder, IconButton } from '@amzn/ring-ui-react-components';
import { displayFileSize } from './utils';
import { Box, BoxBasedComponentProps } from '../Box';
import { Flex } from '../Flex';
import { Icon } from '../Icon';

export type FileDetailsProps = BoxBasedComponentProps<
  'div',
  {
    name: string;
    onDelete?: () => void;
    size: number;
  }
>;

export const MediaUploaderFileDetails = ({
  name,
  onDelete,
  size,
  ...props
}: FileDetailsProps) => {
  const formattedSize = size > 0 ? displayFileSize(size) : null;

  return (
    <Flex justifyContent="space-between" {...props}>
      <Flex flexDirection="column" justifyContent="center">
        <Box textStyle="body-large-medium">{name}</Box>
        <Box textStyle="body-small-light">{formattedSize}</Box>
      </Flex>
      {onDelete && (
        <IconButton
          {...defaultBorder}
          aria-label="Delete media"
          borderRadius="full"
          boxSize={10}
          color="negative.500"
          icon={<Icon name="delete" />}
          onClick={onDelete}
          variant="unstyled"
        />
      )}
    </Flex>
  );
};
